import { useMultiSelectFilter } from './useMultiSelectFilter';
import { useQuery } from '@tanstack/react-query';
import { MultiSelectFilterProps, MultiSelectOption } from './MultiSelect.types';

type RemoteFilterParams<T> = {
  groupSort?: (a: [string, MultiSelectOption[]], b: [string, MultiSelectOption[]]) => number;
  mapOption: (item: T) => MultiSelectOption;
  groupBy?: (item: T) => string;
  query: () => Promise<T[]>;
  selectorLabel: string;
  persistKey: string;
  key: string[];
  id: string;
};

export const useRemoteFilter = <T>({
  selectorLabel,
  persistKey,
  groupSort,
  mapOption,
  groupBy,
  query,
  key,
  id,
}: RemoteFilterParams<T>): {
  data: T[];
  isError: boolean;
  isLoading: boolean;
  filterProps: MultiSelectFilterProps;
} => {
  const {
    data = [],
    isLoading,
    isError,
  } = useQuery(key, query, {
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });

  const { filterProps } = useMultiSelectFilter<T>({
    id,
    data,
    selectorLabel,
    mapOption,
    persistKey,
    groupBy,
    groupSort,
  });

  return { filterProps, data, isLoading, isError };
};
